<template>
  <div class="form-check p-0">
    <input
      :id="id"
      class="form-check-input02"
      type="checkbox"
      :name="name"
      :checked="isChecked"
      @change="handleChange"
    />
    <label :for="id" class="custom-control-label">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialCheckbox",
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [Array, Boolean],
      default: false
    },
    value: {
      type: [String, Number, Boolean],
      default: null
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value)
      }
      return this.modelValue
    }
  },
  methods: {
    handleChange(event) {
      const isChecked = event.target.checked
      
      if (Array.isArray(this.modelValue)) {
        // 다중 선택 모드
        const newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          const index = newValue.indexOf(this.value)
          if (index > -1) {
            newValue.splice(index, 1)
          }
        }
        this.$emit('update:modelValue', newValue)
      } else {
        // 단일 선택 모드
        this.$emit('update:modelValue', isChecked)
      }
      
      this.$emit('change', isChecked)
    }
  }
};
</script>

<style>
.form-check-input02 {
  width: 1.23em;
  height: 1.23em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #d2d2d2;
  border-radius: 0.35em;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  print-color-adjust: exact;
  transition: all 0.25s ease;
  position: relative;
}

.form-check-input02:checked {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

.form-check-input02:checked::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 45%;
  width: 0.35em;
  height: 0.6em;
  border: solid white;
  border-width: 0 0.15em 0.15em 0;
  transform: translate(-50%, -50%) rotate(45deg);
}

.form-check-input02:focus {
  border-color: #4CAF50;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(76, 175, 80, 0.25);
}

.custom-control-label {
  margin-left: 0.5rem;
  cursor: pointer;
}
</style>
